// extracted by mini-css-extract-plugin
export default {"addButton":"LabelsStep_addButton__vxcSF","items":"LabelsStep_items__cZWCM"};